import { IonButton, IonButtons, IonChip, IonCol, IonGrid, IonIcon, IonLabel, IonRow, IonToast } from '@ionic/react';
import { addCircle, arrowBack, closeOutline, removeCircle, trash } from 'ionicons/icons';
import React, { useEffect, useState } from 'react';
import OrdensProdutosCompor from '../../OrdensProdutosCompor/OrdensProdutosCompor';

interface Props {
  dadosEmpresa: any;
  produtos: any[];
  setProdutos: (produtos: any[]) => void;
  clienteNome: string;
  onNext: () => void;
  onBack: () => void;
}

const TelaCardapio: React.FC<Props> = ({ dadosEmpresa, produtos, setProdutos, clienteNome, onNext, onBack }) => {
  const [reloadCatalogo, setReloadCatalogo] = useState(false);
  const [valorTotalProdutos, setValorTotalProdutos] = useState('0,00');
  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState('');

  // Recalculate total on mount (fixes zero value when returning to this screen)
  useEffect(() => {
    if (produtos && produtos.length > 0) {
      recalcularTotal(produtos);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function recalcularTotal(lista: any[]) {
    const totalValor = lista.reduce((total: any, item: any) => {
      const itemValorNumerico = parseFloat(
        item.subtotal.toString().replace(/\./g, '').replace(/\,/g, '.')
      );
      return total + itemValorNumerico;
    }, 0);
    setValorTotalProdutos(totalValor.toLocaleString('pt-br', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }));
  }

  // Matching CaixaProdutosMemory's adicionarItem
  async function adicionarItem(produto: any) {
    if (produto) {
      const updatedList = [...produtos, produto];
      setProdutos(updatedList);
      recalcularTotal(updatedList);
      setTextToast("Item adicionado!");
      setShowToast(true);
    }
  }

  function deletarItemProdutos(index: number) {
    const updatedList = produtos.filter((_: any, i: any) => i !== index);
    setProdutos(updatedList);
    recalcularTotal(updatedList);
  }

  function limparCarrinho() {
    setProdutos([]);
    setValorTotalProdutos('0,00');
  }

  const nomeExibir = clienteNome && clienteNome !== 'Cliente' && clienteNome !== 'Cliente Totem' ? clienteNome : '';

  // Render cart items - matching CaixaProdutosMemory's loadItemProdutos
  const loadItemProdutos = () => {
    if (!produtos || produtos.length === 0) {
      return (
        <div style={{ padding: '16px', textAlign: 'center', color: '#999' }}>
          <p>Nenhum item adicionado</p>
        </div>
      );
    }

    return (
      <IonGrid>
        {produtos.map((value: any, index: any) => (
          <React.Fragment key={index}>
            <div style={{ position: 'relative' }}>
              <div style={{ position: 'absolute', top: '4px', right: '0px', textAlign: 'right' }}>
                <IonChip style={{ height: "20px", backgroundColor: 'var(--ion-color-success)', color: '#fff', fontWeight: 'bold' }}>
                  NOVO
                </IonChip>
              </div>
            </div>

            <IonRow style={{ borderColor: '#dddddd', borderWidth: '1px', borderBottomStyle: 'dashed' }}>
              <IonCol size="9">
                {(value.descricao && Array.isArray(value.descricao)) ? (
                  <>
                    {(value.tipo === "pizzas") ? (
                      <div>{value.tamanho} {value.quantidadeSabores} SABORES</div>
                    ) : (
                      <div>{value.categoria}</div>
                    )}
                    {value.descricao.map((item: any, descIndex: number) => (
                      <div key={"desc" + descIndex}>
                        {item.categoria === "Observação" ? (
                          <div style={{ textDecoration: "underline" }}>
                            Observação: {item.descricao}
                          </div>
                        ) : (
                          <div>
                            - {item.descricao}{" "}
                            <IonLabel style={{ textAlign: "right", fontSize: "12px" }}>
                              R$ {item.valor}
                            </IonLabel>
                          </div>
                        )}
                      </div>
                    ))}
                  </>
                ) : (
                  <div>
                    {value.descricao} (<IonLabel style={{ textAlign: "right", fontSize: "12px" }}>R$ {value.valor}</IonLabel>)
                  </div>
                )}
              </IonCol>

              <IonCol style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }} size="3">
                <IonLabel style={{ textAlign: "right" }}>{value.subtotal}</IonLabel>
              </IonCol>

              <IonCol size="6">
                <IonLabel style={{ textAlign: "right", fontSize: "12px" }}>
                  <IonChip style={{ margin: 0, padding: '5px' }}>
                    <IonIcon size='large' color='danger' icon={removeCircle} onClick={() => {
                      const updatedList = [...produtos];
                      const itemToUpdate = { ...updatedList[index] };
                      const quantidadeFormatada = parseFloat(
                        itemToUpdate.quantidade.toString().replace(/\./g, '').replace(/\,/g, '.')
                      );
                      if (quantidadeFormatada > 1) {
                        const quantidadeNova = quantidadeFormatada - 1;
                        const valorFormatado = parseFloat(
                          itemToUpdate.valor.toString().replace(/\./g, '').replace(/\,/g, '.')
                        );
                        itemToUpdate.quantidade = quantidadeNova;
                        itemToUpdate.subtotal = (quantidadeNova * valorFormatado).toLocaleString('pt-br', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        });
                        updatedList[index] = itemToUpdate;
                        setProdutos(updatedList);
                        recalcularTotal(updatedList);
                      }
                    }} />
                    <IonLabel style={{ fontSize: '20px' }}>
                      {typeof value.quantidade === 'number'
                        ? value.quantidade.toLocaleString('pt-br', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
                        : value.quantidade}
                    </IonLabel>
                    <IonIcon size='large' color='success' icon={addCircle} onClick={() => {
                      const updatedList = [...produtos];
                      const itemToUpdate = { ...updatedList[index] };
                      const quantidadeFormatada = parseFloat(
                        itemToUpdate.quantidade.toString().replace(/\./g, '').replace(/\,/g, '.')
                      );
                      const quantidadeNova = quantidadeFormatada + 1;
                      const valorFormatado = parseFloat(
                        itemToUpdate.valor.toString().replace(/\./g, '').replace(/\,/g, '.')
                      );
                      itemToUpdate.quantidade = quantidadeNova;
                      itemToUpdate.subtotal = (quantidadeNova * valorFormatado).toLocaleString('pt-br', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      });
                      updatedList[index] = itemToUpdate;
                      setProdutos(updatedList);
                      recalcularTotal(updatedList);
                    }} />
                  </IonChip>
                </IonLabel>
              </IonCol>

              <IonCol style={{ display: "flex", justifyContent: "flex-end" }} size="6">
                <IonButton fill="clear" onClick={() => deletarItemProdutos(index)}>
                  <IonIcon color="danger" icon={trash} />
                </IonButton>
              </IonCol>
            </IonRow>
          </React.Fragment>
        ))}
      </IonGrid>
    );
  };

  return (
    <div className="totem-tela-cardapio">
      {/* Header */}
      <div className="totem-cardapio-header">
        <IonButtons>
          <IonButton fill="clear" color="medium" onClick={onBack} className="totem-btn-voltar">
            <IonIcon icon={arrowBack} slot="icon-only" />
          </IonButton>
        </IonButtons>
        <div className="totem-cardapio-titulo">
          {nomeExibir
            ? <span>Oi, <strong>{nomeExibir}</strong>! Monte seu pedido</span>
            : <span>Monte seu pedido</span>}
        </div>

        {produtos.length > 0 && (
          // <IonButton fill="outline" color="medium" onClick={limparCarrinho} style={{ '--border-radius': '10px' }}>
          //   Limpar
          // </IonButton>
          <IonButton fill="clear" color="danger" onClick={limparCarrinho}>
            <IonIcon icon={closeOutline} slot="start" /> Limpar
          </IonButton>
        )}
      </div>

      <div className="totem-cardapio-body">
        {/* Left: Cart */}


        {/* Right: OrdensProdutosCompor */}
        <div className="totem-catalogo-panel">
          <OrdensProdutosCompor
            empresa={dadosEmpresa}
            corPrimaria="danger"
            disabled={false}
            adicionarItem={adicionarItem}
            reload={reloadCatalogo}
            onReloadComplete={() => { setReloadCatalogo(false); }}
          />
        </div>

        <div className="totem-carrinho-panel">
          <h3 style={{ padding: '8px 12px', margin: 0, fontWeight: 700, fontSize: '25px', borderBottom: '1px solid grey' }}>
            Carrinho ({produtos.length})
          </h3>
          <div className="totem-carrinho-list">
            {loadItemProdutos()}
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="totem-cardapio-footer">
        <div className="totem-carrinho-resumo">
          <span className="totem-valor-total">R$ {valorTotalProdutos}</span>
        </div>

        <IonButton
          size="large"
          color="danger"
          disabled={produtos.length === 0}
          onClick={onNext}
        >
          Continuar
        </IonButton>
      </div>

      <IonToast
        isOpen={showToast}
        onDidDismiss={() => setShowToast(false)}
        message={textToast}
        duration={2000}
        position="middle"
      />
    </div>
  );
};

export default TelaCardapio;
